<script setup lang="ts">
// Métadonnées de la page rabais Extra
import type { DropdownMenuItem } from '@nuxt/ui'

useHead({
  title: 'Rabais Extra - Glouton',
  meta: [
    { name: 'description', content: 'Découvrez les rabais exclusifs réservés aux membres Extra. Économisez encore plus avec nos partenaires.' },
    { property: 'og:title', content: 'Rabais Extra - Glouton' },
    { property: 'og:description', content: 'Découvrez les rabais exclusifs réservés aux membres Extra. Économisez encore plus avec nos partenaires.' },
  ],
})

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: '/extra-discounts',
    fr: '/rabais-extra',
  },
})

definePageMeta({
  name: 'ExtraDiscountsPage',
})

const userStore = useUserStore()
const config = useRuntimeConfig()
const modalStore = useModalStore()
const overlay = useOverlay()

const discounts = ref([])
const forAllMembers = ref(true)
const onlyExtraMembers = ref(true)
const countFree = ref(0)
const countExtra = ref(0)

const filters = computed(() => [{
  label: 'Pour tous les membres',
  type: 'checkbox' as const,
  countval: countFree,
  checked: forAllMembers.value,
  onUpdateChecked(checked: boolean) {
    forAllMembers.value = checked
  },
  onSelect(e: Event) {
    e.preventDefault()
  },
}, {
  label: 'Réservés aux membres Extra',
  type: 'checkbox' as const,
  countval: countExtra,
  checked: onlyExtraMembers.value,
  onUpdateChecked(checked: boolean) {
    onlyExtraMembers.value = checked
  },
  onSelect(e: Event) {
    e.preventDefault()
  },
}] satisfies DropdownMenuItem[])

// fetch everything at once, no pagination
async function fetchDiscounts() {
  return await $fetch(`${config.public.apiUrl}/extra-discounts/fetch-discounts`, {
    query: {
      for_all_members: forAllMembers.value,
      only_extra_members: onlyExtraMembers.value,
    },
  })
}

// SSR + hydration
const { data: discountsData, pending, refresh } = await useAsyncData(
  'extra-discounts',
  () => fetchDiscounts(),
)

// update local state
watch(
  discountsData,
  (newData) => {
    if (newData) {
      discounts.value = newData.discounts || []
      countFree.value = newData.count_free || 0
      countExtra.value = newData.count_extra || 0
    }
  },
  { immediate: true },
)

watch([forAllMembers, onlyExtraMembers], () => {
  refresh()
})
</script>

<template>
  <div id="ExtraDiscountsPage">
    <TopNav
      title="Rabais Extra"
      description="Nos membres profitent de nombreux rabais chez nos partenaires. À utiliser sans modération!"
      access="Certains rabais sont réservés à nos membres Extra."
      :total="discounts.length"
      class="mx-auto max-w-8xl w-full"
    />
    <UContainer id="ExtraDiscountsPage-anchor">
      <div class="my-4">
        <UDropdownMenu :items="filters" :content="{ align: 'start', sideOffset: 1 }" :ui="{ content: 'w-68' }" class="group">
          <UButton
            label="Filtrer" trailing-icon="i-mdi-menu-down" color="secondary" :ui="{
              trailingIcon: 'group-data-[state=open]:rotate-180 transition-transform duration-200',
            }"
          />
          <template
            #item-label="{ item }"
          >
            {{ item.label }} <UBadge size="sm" variant="soft" color="secondary">
              {{ item.countval }}
            </UBadge>
          </template>
        </UDropdownMenu>
      </div>

      <div class="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-3">
        <ul class="grid grid-cols-1 gap-6 pb-4 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
          <ExtraDiscountCard
            v-for="discount in discounts"
            :key="discount.id"
            :item="discount"
          />
        </ul>
      </div>
    </UContainer>
  </div>
</template>
